var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container copyright text-center"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" 原來是洋蔥股份有限公司 "),_c('br'),_vm._v(" Itsonion Co., Ltd. All Rights Reserved."),_c('br')])])}
var staticRenderFns = []

export { render, staticRenderFns }